import { render, staticRenderFns } from "./ProductSelectOption.vue?vue&type=template&id=161ff763&"
import script from "./ProductSelectOption.vue?vue&type=script&lang=js&"
export * from "./ProductSelectOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports